module.exports = {
      id: "boost-icon-usage",
      viewBox: "0 0 25 30",
      url: __webpack_public_path__ + "sprite-b16b2d73f82c96a320ba0490c6416430.svg#boost-icon",
      toString: function () {
        return this.url;
      }
    }